import React from "react";
import { connect } from "react-redux";

import {
  doCreateOrder,
  doUploadOrders,
  doDetailOrder,
  doDetailTrackingOrder,
  doDetailPublicOrder,
  doUpdateOrder,
  doGetAllOrders,
} from "../stores/thunk";

import { doGetAllGroups } from "../../group/stores/thunk";
import { selectAllGroups } from "../../group/stores/slice";

import { doGetAllDrivers } from "../../driver/stores/thunk";
import { selectAllDrivers } from "../../driver/stores/slice";

export default Component => {
  class Container extends React.Component {
    componentDidMount() {
      const { id, doDetailOrder } = this.props;
      if (id) {
        doDetailOrder(id);
      }
    }
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state, props) {
    const { match } = props;
    const params = match.params;
    return {
      id: params.id,
      orderCode: params.orderCode,
      action: state.order.action,
      isFetching: state.order.isFetching,
      status: state.order.status,
      message: state.order.message,
      order: state.order.item,
      user: state.auth.user,
      groups: selectAllGroups(state),
      drivers: selectAllDrivers(state),
    };
  }

  return connect(mapStateToProps, {
    doDetailOrder,
    doDetailTrackingOrder,
    doDetailPublicOrder,
    doUpdateOrder,
    doCreateOrder,
    doUploadOrders,
    doGetAllGroups,
    doGetAllDrivers,
    doGetAllOrders,
  })(Container);
};
